import * as Yup from "yup";

/**
 * The reason a payer rejects or a contractor disputes an invoice. The API
 * requires it, so the field is enforced inline rather than by a 422.
 */
export const validatorDisputeReason = Yup.string()
  .trim()
  .required("Please enter a reason");
